// HtmlVsXhtml.jsx
import React from "react";

const HtmlVsXhtml = () => {
  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif", lineHeight: "1.6" }}>
      <h1>HTML vs XHTML - Comprehensive Comparison</h1>

      {/* Introduction */}
      <section id="introduction">
        <h2>1. Introduction</h2>
        <p>
          HTML (HyperText Markup Language) and XHTML (Extensible HyperText Markup Language) are both markup
          languages used to create web pages. XHTML is a stricter and XML-based version of HTML.
        </p>
      </section>

      {/* Definition */}
      <section id="definition">
        <h2>2. Definitions</h2>
        <ul>
          <li>
            <strong>HTML:</strong> A markup language used to structure and present content on the web.
          </li>
          <li>
            <strong>XHTML:</strong> A stricter, XML-compliant version of HTML designed to ensure well-formed
            documents.
          </li>
        </ul>
      </section>

      {/* Key Differences */}
      <section id="differences">
        <h2>3. Key Differences Between HTML and XHTML</h2>
        <table border="1" cellPadding="8" style={{ borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th>Aspect</th>
              <th>HTML</th>
              <th>XHTML</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Syntax Rules</td>
              <td>Lenient, browsers try to fix errors automatically</td>
              <td>Strict, must be well-formed XML</td>
            </tr>
            <tr>
              <td>Case Sensitivity</td>
              <td>Tags are not case-sensitive (<code>&lt;DIV&gt;</code> same as <code>&lt;div&gt;</code>)</td>
              <td>Tags must be lowercase (<code>&lt;div&gt;</code> only)</td>
            </tr>
            <tr>
              <td>Closing Tags</td>
              <td>Optional for some elements (<code>&lt;br&gt;</code>)</td>
              <td>All elements must be closed (<code>&lt;br /&gt;</code>)</td>
            </tr>
            <tr>
              <td>Attribute Values</td>
              <td>Quotes optional for some attributes</td>
              <td>All attribute values must be quoted</td>
            </tr>
            <tr>
              <td>Document Type</td>
              <td>Uses HTML DOCTYPE</td>
              <td>Uses XHTML DOCTYPE</td>
            </tr>
            <tr>
              <td>Error Handling</td>
              <td>Browsers try to render even with errors</td>
              <td>Browsers may refuse to render malformed XHTML</td>
            </tr>
          </tbody>
        </table>
      </section>

      {/* Syntax Examples */}
      <section id="syntax-examples">
        <h2>4. Syntax Examples</h2>

        <h3>HTML Example</h3>
        <pre>
          <code>
{`<!DOCTYPE html>
<html>
  <head>
    <title>HTML Example</title>
  </head>
  <body>
    <h1>Hello HTML</h1>
    <br>
    <img src="image.jpg" alt="Sample Image">
  </body>
</html>`}
          </code>
        </pre>

        <h3>XHTML Example</h3>
        <pre>
          <code>
{`<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN"
  "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">
<html xmlns="http://www.w3.org/1999/xhtml">
  <head>
    <title>XHTML Example</title>
  </head>
  <body>
    <h1>Hello XHTML</h1>
    <br />
    <img src="image.jpg" alt="Sample Image" />
  </body>
</html>`}
          </code>
        </pre>
      </section>

      {/* Best Practices */}
      <section id="best-practices">
        <h2>5. Best Practices</h2>
        <ul>
          <li>Use HTML5 for modern web development; it is simpler and widely supported.</li>
          <li>Use XHTML if strict XML compliance is required (e.g., for XML parsers).</li>
          <li>Always ensure proper nesting and closing of tags.</li>
          <li>Use lowercase tags and quote all attribute values for XHTML.</li>
        </ul>
      </section>

      {/* Summary */}
      <section id="summary">
        <h2>6. Summary</h2>
        <p>
          HTML is more forgiving and easier to write, while XHTML enforces stricter XML rules. Choosing between
          them depends on the need for strict syntax versus ease of use.
        </p>
      </section>
    </div>
  );
};

export default HtmlVsXhtml;
